import React from 'react';
import { json } from 'react-router-dom';

const callAppFunc = (fnName, params) => {
  const jsonStr = {
    fnName: fnName,
    params: params,
  };
  if (typeof window !== 'undefined' && window.callAppFn) {
    // eslint-disable-next-line no-undef
    callAppFn(JSON.stringify(jsonStr));
  }
};

const callNativeAppFunc = (fnName, param = {}) => {
  console.log('JSPWEB', fnName, param);
  if (typeof window !== 'undefined') {
    if (fnName === 'onSignIn') {
      console.log('JSPWEB', 'onSignIn');
      try {
        window.webkit.messageHandlers.onSignIn.postMessage('');
      } catch (err) {}

      try {
        UniProsperityMobileApp.onSignIn();
      } catch (err) {}
    } else if (fnName === 'onSignOut') {
      console.log('JSPWEB', 'onSignOut');
      try {
        window.webkit.messageHandlers.onSignOut.postMessage('');
      } catch (err) {}
      try {
        UniProsperityMobileApp.onSignOut();
      } catch (err) {}
    } else if (fnName === 'closeJSPWebview') {
      console.log('JSPWEB', 'closeJSPWebview');
      try {
        window.webkit.messageHandlers.closeJSPWebview.postMessage('');
      } catch (err) {}
      try {
        UniProsperityMobileApp.closeJSPWebview();
      } catch (err) {}
    } else if (fnName === 'openURI') {
      console.log('JSPWEB', 'openURI', param?.url);
      try {
        window.webkit.messageHandlers.openURI.postMessage(param?.url || '');
      } catch (err) {}
      try {
        UniProsperityMobileApp.openURI(param?.url || '');
      } catch (err) {}
    } else if (fnName === 'redirectToUrl') {
      const redirectPayload = JSON.stringify({
        type: param?.type || '2',
        url: param?.url || '',
      });
      console.log('JSPWEB', 'redirectToUrl', redirectPayload);
      try {
        window.webkit.messageHandlers.redirectToUrl.postMessage(
          redirectPayload
        );
      } catch (err) {}
      try {
        UniProsperityMobileApp.redirectToUrl(redirectPayload);
      } catch (err) {}
    }
  }
};

export { callAppFunc, callNativeAppFunc };

const WebFn = ({ callback }) => {
  // console.log('data', data);
  if (typeof window !== 'undefined') {
    window.callWebFn = (jsonStr) => {
      callback(jsonStr);
    };
  }
};

export default WebFn;
